





















import { ColumnConfiguration } from '@/types';
import { BvTableField } from 'bootstrap-vue';
import Vue, { PropType } from 'vue';
import { Dictionary } from 'vue-router/types/router';
import { Container, Draggable } from 'vue-smooth-dnd';

export default Vue.extend({
  props: {
    value: {
      default: [],
      type: Array as PropType<ColumnConfiguration[]>
    },
    columns: {
      required: true,
      type: Array as PropType<Array<{ key: string } & BvTableField>>
    }
  },
  data() {
    return {
      showColumnReorderModal: false,
      reorderedColumns: [] as ColumnConfiguration[]
    };
  },
  computed: {
    columnDefinitions() {
      return this.columns.reduce((columnDefinitions, column) => ({ ...columnDefinitions, [column.key]: { ...column } as BvTableField }), {} as Dictionary<BvTableField>);
    },
    orderedColumns() {
      const orderedColumns: ColumnConfiguration[] = this.value;
      const unorderedColumns: ColumnConfiguration[] = (this.columns as Array<{ key: string } & BvTableField>)
        .filter((column) => !this.value.find((columnConfiguration: ColumnConfiguration) => columnConfiguration.key === column.key))
        .map(({ key }) => ({ key, visible: true }));
      return [...orderedColumns, ...unorderedColumns];
    }
  },
  methods: {
    onReorderColumns(this: any) {
      this.reorderedColumns = [...this.orderedColumns];
      this.showColumnReorderModal = true;
    },
    onDrop(this: any, { addedIndex, removedIndex }: { addedIndex: number; removedIndex: number }) {
      const removedItem = (this.reorderedColumns as Array<{ key: string }>).splice(removedIndex, 1)[0];
      (this.reorderedColumns as Array<{ key: string }>).splice(addedIndex, 0, removedItem);
    },
    onCancelReorder(this: any) {
      this.showColumnReorderModal = false;
      this.reorderedColumns = [];
    },
    onOkayReorder(this: any) {
      this.$emit('input', [...this.reorderedColumns]);
      this.showColumnReorderModal = false;
    },
    onToggleColumnVisibility(this: any, index: number, visible: boolean) {
      Vue.set(this.reorderedColumns, index, { ...this.reorderedColumns[index], visible });
    }
  },
  components: { Container, Draggable }
});
